function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../../../Common/LoadingUI";
import AiOutlineExclamationCircle from "@meronex/icons/ai/AiOutlineExclamationCircle";
import { giftSvg } from "../../../../DealsAndDiscounts/Components/Header/svg";
import { isRewardsVisible } from "../../../../../utils/routing";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var terms = [{
  id: 0,
  title: /*#__PURE__*/_jsx("label", {
    "for": 0,
    className: " ml-2 text-sm flex-1",
    children: "I confirm that I have not represented or made any statements that are contrary to the official RERA (Real Estate Regulatory Authority) details of the project."
  })
}, {
  id: 1,
  title: /*#__PURE__*/_jsx("label", {
    "for": 1,
    className: " ml-2 text-sm flex-1",
    children: "I acknowledge that 10% TDS will be deducted at the time of payout, and this amount will be reflected in my Form 26AS for tax purposes."
  })
}, {
  id: 2,
  title: /*#__PURE__*/_jsxs("p", {
    className: " ml-2 text-sm",
    children: ["I agree to the", " ", /*#__PURE__*/_jsx("a", {
      className: "text-[#006EB7] underline",
      href: "".concat(window.reloy_env.PUBLIC_URL, "/terms-and-conditions"),
      children: "Terms & Conditions"
    }), " ", "and", " ", /*#__PURE__*/_jsx("a", {
      className: "text-[#006EB7] underline",
      href: "https://reloy.co/privacy-policy/",
      children: "Privacy Policy"
    }), " ", "laid out by Loyalie IT Solutions Pvt Ltd."]
  })
}, {
  id: 3,
  title: /*#__PURE__*/_jsx("p", {
    className: " ml-2 text-sm",
    children: "I confirm that I am not liable to pay GST in the account where I am receiving the funds."
  })
}, {
  id: 4,
  title: /*#__PURE__*/_jsx("label", {
    "for": 4,
    className: " ml-2 text-sm flex-1",
    children: "I understand that payouts made to me may fall under Section 194J of the Income Tax Act, which applies to fees for professional or technical services. As a result, I may be subject to tax deductions under this section, where applicable."
  })
}, {
  id: 5,
  title: /*#__PURE__*/_jsx("label", {
    "for": 5,
    className: " ml-2 text-sm flex-1",
    children: "I am solely responsible for reporting this income in my ITR (Income Tax Return) filings. I agree to comply with all applicable tax laws, including the accurate disclosure of income received from these payouts."
  })
}];
var FirstStep = function FirstStep(_ref) {
  var setStep = _ref.setStep,
    loading = _ref.loading,
    checkKycVerificationStatus = _ref.checkKycVerificationStatus,
    error = _ref.error,
    setOpenUploadBox = _ref.setOpenUploadBox,
    initiateWorkflow = _ref.initiateWorkflow,
    closeKYCModal = _ref.closeKYCModal;
  var _useState = useState([false, false, false, false, false, false]),
    _useState2 = _slicedToArray(_useState, 2),
    checkedState = _useState2[0],
    setCheckedState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showNoGSTDisclaimer = _useState4[0],
    setNoGSTDisclaimer = _useState4[1];
  var allChecked = checkedState.every(function (item, i) {
    return i === 3 ? true : item === true;
  });
  var noGST = !checkedState[3];
  useEffect(function () {
    return setCheckedState(checkedState.map(function (item) {
      return false;
    }));
  }, []);
  var acceptTerms = function acceptTerms() {
    setCheckedState(checkedState.map(function (item) {
      return true;
    }));
  };
  var handleOnChange = function handleOnChange(position) {
    var updatedCheckedState = checkedState.map(function (item, index) {
      return index === position ? !item : item;
    });
    setCheckedState(updatedCheckedState);
    if (updatedCheckedState[position]) {
      var _window;
      (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("TnCSelected");
    }
  };
  var onContinue = function onContinue() {
    var _window2;
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webengage) === null || _window2 === void 0 || _window2.track("TnCAccepted");
    if (showNoGSTDisclaimer) {
      setOpenUploadBox(false);
    } else if (noGST) {
      setNoGSTDisclaimer(true);
    } else {
      // checkKycVerificationStatus();

      /*Previous flow was to redirec t to digilocker after tnc*/

      // initiateWorkflow('DIGILOCKER')
      setStep(4);
    }
  };
  return /*#__PURE__*/_jsx("div", {
    className: "px-3 md:px-8 py-4",
    children: loading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : error ? /*#__PURE__*/_jsxs("div", {
      className: " flex flex-col justify-center items-center text-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: " rounded-full bg-red-500 p-2 md:p-4 ",
        children: /*#__PURE__*/_jsx(AiOutlineExclamationCircle, {
          className: " text-white h-7 w-7 md:h-8 md:w-8"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "leading-5 mt-3",
        children: error
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [showNoGSTDisclaimer ? /*#__PURE__*/_jsxs("div", {
        children: ["Email the required documents to accounts@reloy.co and we will process the payout accordingly.", " "]
      }) : /*#__PURE__*/_jsxs("div", {
        className: "",
        children: [" ", /*#__PURE__*/_jsxs("div", {
          className: "flex justify-between pb-0 md:pb-2 ",
          children: [/*#__PURE__*/_jsx("h1", {
            className: " font-Poppins font-bold text-lg ",
            children: "Terms & Conditions"
          }), /*#__PURE__*/_jsx("button", {
            onClick: acceptTerms,
            className: "text-lg text-[#006EB7] underline",
            children: "Select all"
          })]
        }), terms.map(function (term) {
          return /*#__PURE__*/_jsxs("div", {
            className: "flex my-3",
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              onChange: function onChange() {
                return handleOnChange(term.id);
              },
              id: term.id,
              value: term.title,
              checked: checkedState[term.id],
              className: "checkbox-sm bg-white rounded-md border-gray-100 checked:bg-blue-600",
              autoComplete: "off"
            }), term.title]
          });
        })]
      }), !showNoGSTDisclaimer && /*#__PURE__*/_jsx("div", {
        className: "flex pt-8",
        children: /*#__PURE__*/_jsx("button", {
          onClick: onContinue,
          disabled: !allChecked || loading,
          className: "disabled:bg-[#BFBFBF] disabled:cursor-not-allowed bg-primary w-full text-white rounded font-bold px-6 h-8 md:h-10 ",
          children: "Accept"
        })
      }), isRewardsVisible && /*#__PURE__*/_jsxs("div", {
        onClick: closeKYCModal,
        className: "flex p-4 border-2 rounded-xl  cursor-pointer ".concat(showNoGSTDisclaimer ? "mt-11" : "mt-7"),
        children: [giftSvg, /*#__PURE__*/_jsxs("div", {
          className: "ml-2",
          children: [/*#__PURE__*/_jsx("h1", {
            className: "font-semibold",
            children: "Want to claim the whole amount?"
          }), /*#__PURE__*/_jsx("p", {
            className: "text-sm",
            children: "Redeem your reward at our exclusive store"
          })]
        })]
      })]
    })
  });
};
export default FirstStep;